import baseAPI, { fileUploadInstance } from '../app/axios';
import config from '../app/config';

export default class FileService {
  static async upload(file, onUploadProgress) {
    // get file url
    const response = await fileUploadInstance.get(
      `${config.UPLOAD_URL}/${encodeURIComponent(file.name)}`,
    );

    // put file to server
    await fileUploadInstance.put(response.url, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress,
    });

    return { name: file.name, url: response.location };
  }

  static async videoTranscoding(fileUrl, orgId) {
    await baseAPI.post(`/template/video_transcoding?orgId=${orgId}`, {
      type: 's3',
      bucket: 'assets.no8.io',
      key: fileUrl.replace('https://assets.no8.io/', ''),
    });
  }
}
